module.exports = __webpack_public_path__ + "static/dd-madde1-bef4fb6d83b27babd012014ee830509c.png";